/*! React Starter Kit | MIT License | http://www.reactstarterkit.com/ */

import React, { Component } from 'react';
import styles from './Header.css';
import withStyles from '../../decorators/withStyles';
import Link from '../Link';

import { Button } from 'react-bootstrap';

@withStyles(styles)
class Header extends Component {

  render() {
    return (
      <div className="Header">
        <div className="Header-container">
          <div className="Header-banner">
            <a className="Header-link" href="/" onClick={Link.handleClick}>
              <img alt="SVG 2 STL Logo" src={require('./logo.png')} />
            </a>
            <p className="Header-bannerDesc">3D printing SVG's made simple&nbsp;|&nbsp;<a className="Header-link" href="/gallery" onClick={Link.handleClick}>View gallery</a></p>
          </div>
        </div>
      </div>
    );
  }

}

export default Header;



/** WEBPACK FOOTER **
 ** ./src/components/Header/Header.js
 **/